export default __webpack_public_path__ + "static/media/Boneshred Gloves.25895e60.jpg";